// ignore-string-externalization

import { GraphQLClient, ClientError } from 'graphql-request';

function getClient(preview = false) {
  const token = preview
    ? process.env.REACT_APP_CONTENTFUL_PREVIEW_TOKEN
    : process.env.REACT_APP_CONTENTFUL_TOKEN;

  const space = process.env.REACT_APP_CONTENTFUL_SPACE;
  const env = process.env.REACT_APP_CONTENTFUL_ENVIRONMENT || 'master';

  return new GraphQLClient(
    `https://graphql.contentful.com/content/v1/spaces/${space}/environments/${env}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );
}

export async function contentfulGql<T = any>(
  query: string,
  variables?: Record<string, any>,
  preview = false,
): Promise<T> {
  try {
    return await getClient(preview).request<T>(query, variables);
  } catch (error) {
    if (error instanceof ClientError && error.response.data) {
      return error.response.data as T;
    }
    throw error;
  }
}
